import { Component, OnInit, OnDestroy, HostListener, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SidebarService } from '../../Services/sidebar-service.service';
import { CommonModule } from '@angular/common';
import { LogoutmodelComponent } from '../header/logoutmodel/logoutmodel.component';
import { UtilsService } from '../../Services/utils.service';
import { faHouse, faCrown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ApiCallService } from '../../Services/api-call-service.service';
import { HotGamesService } from '../../Services/hot-games.service';

@Component({
  selector: 'app-side-bar',
  imports: [
    RouterModule,
    CommonModule,
    LogoutmodelComponent,
    FontAwesomeModule,
    FormsModule,
  ],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss',
})
export class SideBarComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  isSidebarOpen = false;
  isCollapsed = false;
  isMobile = false;
  faHouse = faHouse;
  faCrown = faCrown;
  // profileImage = '/cmax2-assets/icons/profileimage.png';
  profileImage: string = '';
  userName: any;
  email: any;
  playerLevelName: string = '';

  hotCount = 0;
  tickerVisible = true;
  searchTerm = '';

  constructor(
    private sidebarService: SidebarService,
    private router: Router,
    private utilsService: UtilsService,
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private apiCallService: ApiCallService,
    private hotGamesService: HotGamesService,
  ) { }

  ngOnInit() {
    this.hotGamesService.hotCount$.pipe(takeUntil(this.destroy$)).subscribe((count) => {
      this.hotCount = count;
    });
    // debugger;
    this.sidebarService.sidebarOpen$.pipe(takeUntil(this.destroy$)).subscribe((isOpen) => {
      this.checkScreenSize();
      if (this.isMobile) {
        const drawer = this.elementRef.nativeElement.querySelector('.mobile-sidebar');
        if (drawer) {
          if (isOpen) {
            this.renderer.addClass(drawer, 'open');
          } else {
            this.renderer.removeClass(drawer, 'open');
          }
        }
      } else {
        this.isCollapsed = !this.isCollapsed;
      }

      this.isSidebarOpen = isOpen;
      if (isOpen) {
        this.loadProfileData();
        this.loadPlayerLevel();
      }
    });
    this.loadProfileData();
    this.loadPlayerLevel();
    this.checkScreenSize();
  }

  goToHotGames() {
    this.hotGamesService.scrollToHotGames();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    // profile data is loaded once in ngOnInit and refreshed on every
    // sidebar open — no polling interval needed
  }

  private loadProfileData() {
    this.profileImage =
      localStorage.getItem('profileImage') ??
      '/cmax2-assets/icons/profileimage.png';
    this.userName = localStorage.getItem('userName') ?? '';
    this.email = localStorage.getItem('email') ?? '';
  }

  // Sourced the same way header.component.ts does (Customer/GetCustomerLevel)
  // so the tier badge next to the username in this drawer stays in sync with
  // the header's own player-level badge.
  private loadPlayerLevel() {
    const customerId = localStorage.getItem('customerId');
    if (!customerId) {
      return;
    }

    this.apiCallService
      .GetCallWithToken(`Customer/GetCustomerLevel?CustomerId=${customerId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response && response.responseCode === 200 && response.data) {
            this.playerLevelName = response.data.playerLevel || '';
          }
        },
        error: () => {
          // Non-critical — the tier badge just stays hidden on failure.
        },
      });
  }

  showTopMenuRoutes: string[] = [
    '/dashboard/home',
    '/dashboard/spinner',
    '/dashboard/lottery',
    '/dashboard/scratch',
    '/dashboard/account',
    '/dashboard/wallet',
    '/dashboard/changePass',
    '/dashboard/ranks',
    '/dashboard/Terms&Conditions',
    '/dashboard/KYCform',
    '/dashboard/lottery-history',
    '/dashboard/user-profile',
    '/dashboard/profile',
    '/dashboard/referrals',
    '/dashboard/player-level',
  ];

  shouldShowTopMenu(): boolean {
    return this.showTopMenuRoutes.includes(this.router.url);
  }

  toggleTicker() {
    this.tickerVisible = !this.tickerVisible;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
  }

  RedirectToGuidelines() {
    this.router.navigate(['/dashboard/GuideLines']);
  }
  RedirectToSetting() {
    this.router.navigate(['/dashboard/edit-profile']);
  }

  closeSidebarMobile() {
    // always close through the service so its state stays in sync with the
    // header trigger — toggling here left the two out of step
    this.sidebarService.closeSidebar();
  }
  isLogoutModalOpen: boolean = false;
  closeLogoutModal() {
    this.isLogoutModalOpen = false;
  }
  logout() {
    this.utilsService.triggerLogoutFunction();
  }
  showLogoutModal() {
    this.isLogoutModalOpen = true;
    this.sidebarService.closeSidebar();
  }

  // * Router navigation function
  redirectTo(path: string) {
    this.router.navigate([path]);
    this.utilsService.toggleComponentVisibility(false);
    this.closeSidebarMobile();
  }

  isActive(path: string): boolean {
    return this.router.url === path;
  }
  RedirectToScratchCard() {
    // this.router.navigate(['/dashboard/scratch']);
    this.utilsService.toggleComponentVisibility(false);
    this.closeSidebarMobile();
  }
  redirectToGame(path: string) {
    this.router.navigate([path]);
    this.utilsService.toggleComponentVisibility(false);
    this.closeSidebarMobile();
  }
  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return (
      current === '/dashboard/treasure-pick' ||
      current === '/dashboard/stack-builder' ||
      current === '/dashboard/ace-win' ||
      current === '/dashboard/card-brag-3' ||
      current === '/dashboard/sum-dice' ||
      current === '/dashboard/lucky-trigger' ||
      current === '/dashboard/cashbull' ||
       current === '/dashboard/joker-777' ||
       current === '/dashboard/slot-777' ||
      current === '/dashboard/space-hunt' ||
      current === '/dashboard/StackBuilder' ||
      current === '/dashboard/aviator' ||
      current === '/dashboard/baccarat' ||
      current === '/dashboard/keno' ||
      current === '/dashboard/double' ||
      current === '/dashboard/toss' ||
      current === '/dashboard/slots' ||
      current === '/dashboard/roulette' ||
      current === '/dashboard/chickenroad' ||
      current === '/dashboard/mines' ||
      current === '/dashboard/plinko'
    );
  }
}
